import { Address } from 'viem';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { AuthStore } from './AuthStore.interface';

export const useAuthStore = create(
  devtools(
    persist<AuthStore>(
      (set) => ({
        isLoggedIn: false,
        smartAccountAddress: undefined,
        email: undefined,
        id: undefined,
        signUp: (email: string) => set({ email }),
        logIn: (smartAccountAddress: Address, email: string, id: number) =>
          set({ smartAccountAddress, email, id, isLoggedIn: true }),
        logOut: () =>
          set({
            isLoggedIn: false,
            smartAccountAddress: undefined,
            email: undefined,
            id: undefined,
          }),
      }),
      { name: 'superwallet-auth' },
    ),
  ),
);
